import React from "react";

import TablePaginator from "@app/analytics/components/TablePaginator";
import type { ReportListView } from "@app/analytics/types";
import type { Pagination } from "@app/common/hooks/usePagination";

import Stack, { Row } from "@rui/Stack";

import GroupReportsToggle from "./GroupReportsToggle";
import ReportViewSelector from "./ReportViewSelector";
import SourceFilterMenu from "./SourceFilterMenu";
import TagFilterMenu from "./TagFilterMenu";

interface ReportsMenuProps {
  isLoading: boolean;
  pagination: Pagination;
  view: ReportListView;
  hidePagination?: boolean;
}

const ReportsMenu = ({
  view,
  isLoading,
  pagination,
  hidePagination = false,
}: ReportsMenuProps) => {
  const onIncompleteReportsTab = view === "incomplete";

  return (
    <Row
      variant="apart"
      flexWrap="wrap"
      width="100%"
      marginY={{ xxs: 0, sm: 2 }}
    >
      <Stack
        direction={{ xxs: "column", sm: "row" }}
        variant="left"
        spacing={1}
      >
        {!onIncompleteReportsTab && <ReportViewSelector />}
        <Row spacing={1}>
          {!onIncompleteReportsTab && <GroupReportsToggle />}
          <SourceFilterMenu />
          {!onIncompleteReportsTab && <TagFilterMenu />}
        </Row>
      </Stack>

      {!hidePagination && (
        <TablePaginator
          {...pagination}
          loading={isLoading}
          showPageSizeSelector
        />
      )}
    </Row>
  );
};

export default ReportsMenu;
